import SWC from "components/Stacker/constants/SwatchConstants"

/* eslint-disable import/prefer-default-export */
export function selectSwatch(args) {
  return {
    type: SWC.SWATCH_SELECTED,
    payload: args,
  }
}
